import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetUploadDetail } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'
import moment from "moment";

export default (jobid) => async (dispatch, getState) => {
    dispatch({ type: GetUploadDetail, data: fromJS({}) });
    const Authorization = UserToken;
    const url = ApiUrl2 + '/upload-detail';

    const formbody = new FormData();
    formbody.append('jobid', jobid );

    const argument = {  
        method: 'POST',
        headers : {
            'Authorization': Authorization,
        },
        body : formbody
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        var result = await response.json();
        result =  result.uploads.data[0];
        var approvedDate=result['approved-date'].split('.');
        var rejectedDate=result['rejected-date'].split('.');
        var scheduleDate=result['schedule-date'].split('.');
        //added 202010
        var flagErorDetailReport = false
        var statErorDetailReport = "-"

        // if(result["validation-result"]["invalid-message"]>0 || result["validation-result"]["invalid-msisdn"]>0){
        //     flagErorDetailReport = true
        // }
        // if(flagErorDetailReport==true){
            if(result['validation-file-status-id']==1){
                statErorDetailReport = "Request File"
            }else if(result['validation-file-status-id']==2){
                statErorDetailReport = "File on Process"
            }else if(result['validation-file-status-id']==3){
                statErorDetailReport = "File Ready to Download"
            }
        //}
        //close added 202010

        data = fromJS([
            {'f':'JobId', 'v': jobid },
            {'f':'File Name', 'v': result["file-name"] },
            {'f':'Upload Type', 'v': result["upload-type"] },
            {'f':'Upload Date', 'v': moment(result["upload-date"]).format("DD-MM-YYYY HH:mm:ss")},
            {'f':'Upload By', 'v': result["upload-by"] },
            {'f':"Client", 'v':  result['client'] },
            {'f':"Division", 'v':  result['division'] },
            {'f':"Sender", 'v':  result['sender'] },
            {'f':'Total Valid MSISDN', 'v': result["validation-result"]["valid-msisdn"] },
            {'f':'Total Invalid MSISDN', 'v': result["validation-result"]["invalid-msisdn"] },
            {'f':'Total Valid Message', 'v': result["validation-result"]["valid-message"] },
            {'f':'Total InValid Message', 'v': result["validation-result"]["invalid-message"] },
            {'f':"Download Validation Result", 'v': statErorDetailReport },
            {'f':"Approved Date", 'v': approvedDate[0]},
            {'f':"Approved By", 'v': result['approved-by'] },
            {'f':"Rejected Date", 'v': rejectedDate[0] },
            {'f':"Rejected By", 'v':  result['rejected-by'] },
            {'f':"status", 'v':  result['status'] },
            {'f':"Schedule Date", 'v': scheduleDate[0] },
        ]);
        
        dispatch({ type: GetUploadDetail, data: data });
    }
};